import { render, staticRenderFns } from "./ReadOnlyCommitteeCollaborationEvaluation.vue?vue&type=template&id=f2a655b0&scoped=true&"
import script from "./ReadOnlyCommitteeCollaborationEvaluation.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyCommitteeCollaborationEvaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a655b0",
  null
  
)

export default component.exports